/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from 'react';
import {
  VegaFlex,
  VegaFont,
  VegaBox,
  VegaCheckbox,
  VegaCounterBadge
} from '@heartlandone/vega-react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { showMessageDetail } from 'Slices/Header/messageSlice';
import { dateTimeFormat } from 'Chores/utils';
import MSG_LOGO from '../../Public/Image/msg-logo.svg';
import { DOMParser } from 'linkedom';

const formatEmailBody = (body) => {
  const doc = new DOMParser().parseFromString(body, 'text/html');
  const firstTdText = doc.body
    ?.querySelector('table td')
    ?.textContent
    ?.replace(/\s+/g, ' ')
    ?.trim() ?? '';
  return firstTdText;
};

const MessageItem = ({ messageItem, setLocalMessageList, triggeredMessage, unTriggeredMessage }) => {
  const dispatch = useDispatch();
  const [isDot, setIsDot] = useState(false);
  const [dotCount, setDotCount] = useState(0);
  useEffect(() => {
    if (!messageItem.isRead) {
      setDotCount(1);
      setIsDot(true);
    } else {
      setDotCount(0);
      setIsDot(false);
    }
  }, [messageItem]);

  const onClick = () => {
    if (messageItem.trigger) {
      unTriggeredMessage(messageItem);
      return;
    }
    dispatch(showMessageDetail(messageItem));
    triggeredMessage(messageItem);
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setLocalMessageList((prevList) =>
      prevList.map((message) =>
        message.id === messageItem.id ? { ...message, selected: isChecked } : message
      )
    );
  };

  const formattedCreationTime = messageItem.creationTime ? dateTimeFormat(messageItem.creationTime, 'DD MMM YYYY HH:mm') : '';

  return (
    <>
      <VegaBox
        backgroundColor={messageItem.backgroundColor}
        corners="rounded-8"
        padding="size-12"
      >
        <VegaFlex
          direction="row"
          alignItems="center"
          justifyContent="start"
          gap="size-12"
        >
          <VegaCheckbox
              size="small"
              disabled="false"
              dataVegaForm="checkbox"
              checked={messageItem.selected}
              onVegaChange={handleCheckboxChange}
            >
          </VegaCheckbox>
          <VegaFlex
            direction="row"
            alignItems="center"
            justifyContent="start"
            gap="size-12"
            onClick={onClick}
            style={{ width: '100%', flexGrow: 1 }}
          >
            <img
              data-figma-node-name="Profile Thumbnail"
              height="60"
              width="60"
              src={MSG_LOGO}
            />

            <VegaFlex
              direction="col"
              alignItems="stretch"
              justifyContent="center"
              gap="0"
              style={{ width: '100%' }}
            >
              <VegaFlex
                direction="row"
                alignItems="stretch"
                justifyContent="space-between"
                gap="0"
              >
                <VegaFont
                  color="text-sidebar-link-hover"
                  variant="font-field-label-lg"
                  style={{ display: 'block', verticalAlign: 'top', alignSelf: 'stretch' }}
                  textAlign="left"
                >
                  {messageItem.fromName}
                </VegaFont>
                <VegaFont
                  color="text-secondary"
                  variant="font-field-label-sm"
                  style={{ display: 'block', verticalAlign: 'top', alignSelf: 'stretch' }}
                  textAlign="left"
                >
                  {formattedCreationTime}
                </VegaFont>
              </VegaFlex>
              <VegaBox
                corners="rounded-none"
              >
                <VegaFont
                  color="text-link"
                  variant="font-field-value"
                  style={{
                    display: 'block',
                    verticalAlign: 'top',
                    alignSelf: 'stretch',
                    fontWeight: 700,
                    size: '16px',
                    lineHeight: '24px'
                  }}
                  textAlign="left"
                >
                  {messageItem.subject}
                </VegaFont>
              </VegaBox>

              <VegaBox
                corners="rounded-none"
              >
                <VegaFont
                  color="text-secondary"
                  variant="font-field-label-sm"
                  style={{
                    display: '-webkit-box',
                    verticalAlign: 'top',
                    alignSelf: 'stretch',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 1
                  }}
                  textAlign="left"
                >
                  {messageItem.isBodyHtml ? formatEmailBody(messageItem.body) : messageItem.body}
                </VegaFont>
              </VegaBox>
            </VegaFlex>
          </VegaFlex>
          <VegaBox
            corners="rounded-8"
            padding={{
              left: 'size-12'
            }}
          >
            <VegaCounterBadge count={dotCount} dot={isDot} offset={[-6, -24]}></VegaCounterBadge>
          </VegaBox>
        </VegaFlex>
      </VegaBox>
    </>
  );
};

MessageItem.propTypes = {
  messageItem: PropTypes.object.isRequired,
  setLocalMessageList: PropTypes.func.isRequired,
  triggeredMessage: PropTypes.func.isRequired,
  unTriggeredMessage: PropTypes.func.isRequired
};

export default MessageItem;
